<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        독감예방접종신청
      </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in codeList"
            :key="i"
            class="gntType-item"
          >
            <v-list-item-content @click="selectMenu(item)">
              <!-- 대체휴가 -->
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import {
  getVaccinationCode,
  getVaccinationCostValidChk,
} from '@/api/workStatus';
import routerNames from '@/const/routerConstants';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  data: () => ({
    applLevelSheet: false, // 대상자명 화면플래그
    tgtName: '본인',
    selecttitle: '대상자명',
    realAmnt: '',
    applAmnt: '',
    codeList: [],
    famRshipCd: 'SE', // 기본값 본인
    mgrUserListProps: [],
    myslfSuptCntLimit: 0,
    myslfSuptAmntLimit: 0,
    spousSuptCntLimit: 0,
    spousSuptAmntLimit: 0,
    myslfPayCntSum: 0,
    myslfPayAmntSum: 0,
    spousPayCntSum: 0,
    spousPayAmntSum: 0,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },

  methods: {
    /* 신청서 선택 */
    async selectMenu(item) {

      let params = {
        searchApplSabun: this.GET_USER_DATA.ssnSabun,
        searchApplYmd: dayjs().format('YYYYMMDD'),
      };

      let response = await getVaccinationCostValidChk(params);
      console.dir(response);

      this.myslfSuptCntLimit =
        response.data.data.myslfSuptCnt === null
          ? 0
          : response.data.data.myslfSuptCnt; /* 본인제한횟수 */
      this.myslfSuptAmntLimit =
        response.data.data.myslfSuptAmntLimit === null
          ? 0
          : response.data.data.myslfSuptAmntLimit; /* 본인제한금액 */
      this.spousSuptCntLimit =
        response.data.data.spousSuptCnt === null
          ? 0
          : response.data.data.spousSuptCnt; /* 배우자제한횟수 */
      this.spousSuptAmntLimit =
        response.data.data.spousSuptAmntLimit === null
          ? 0
          : response.data.data.spousSuptAmntLimit; /* 배우자제한금액 */

      this.myslfPayCntSum =
        response.data.data.myslfPayCntSum === null
          ? 0
          : response.data.data.myslfPayCntSum; /* 본인지원횟수 */
      this.myslfPayAmntSum =
        response.data.data.myslfPayAmntSum === null
          ? 0
          : response.data.data.myslfPayAmntSum; /* 본인기지급금액 */
      this.spousPayCntSum =
        response.data.data.spousPayCntSum === null
          ? 0
          : response.data.data.spousPayCntSum; /* 배우자지원횟수 */
      this.spousPayAmntSum =
        response.data.data.spousPayAmntSum === null
          ? 0
          : response.data.data.spousPayAmntSum; /* 배우자기지급금액 */

      this.myslfSuptCntLimit = this.myslfSuptCntLimit - this.myslfPayCntSum;
      this.myslfSuptAmntLimit = this.myslfSuptAmntLimit - this.myslfPayAmntSum;
      this.spousSuptCntLimit = this.spousSuptCntLimit - this.spousPayCntSum;
      this.spousSuptAmntLimit = this.spousSuptAmntLimit - this.spousPayAmntSum;

      let limitCnt = 0;

      // 본인(SE), 배우자(SP)
      if (item.code == 'SE') {
        limitCnt = this.myslfSuptCntLimit;
      } else {
        limitCnt = this.spousSuptCntLimit;
      }

      if ( dayjs().format('YYYYMMDD') >= response.data.data.applSYmd && dayjs().format('YYYYMMDD') <= response.data.data.applEYmd ) {
        console.log('독감예방접종비 신청가능');
      } else {
        alert("독감예방접종비 신청기간이 아닙니다.");
        this.$router.go(-1);
        return;
      }
      
      // 잔여횟수 < 1
      if (limitCnt < 1) {
        alert('지원횟수를 초과 하였습니다.');
        return;
      }

      if (item.tgtName === null) {
        alert('배우자가 없을 경우 배우자 선택 시\n가족관계 사항을 등록 후 신청하시기 바랍니다.');
        this.$router.go(-1);
        return;
      }

      if (response.data.data.stdRegYn !== 'Y') {
        alert("독감예방접종비 기준 정보가 없습니다.\n담당자에게 문의 바랍니다.");
			  return;
      }

      this.$store.commit('SET_FAMRSHIPCD_CD', item.code);
      this.$store.commit('SET_TGT_NAME', item.tgtName);
      this.$router.push(routerNames.VaccinationSub);
    },
  },

  async mounted() {
    /*
    let params = {
      grCodeCd: 'BE0103', // 대상자코드
      note2: 'Y',
    };
    */

    let params = {
      searchApplSabun: this.GET_USER_DATA.ssnSabun,
      searchApplYmd: dayjs().format('YYYYMMDD'),
    };

    let response = await getVaccinationCode(params);
    this.codeList = response.data.data;

    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_FILE_SEQ', '');
  },

  components: {
    IconApprovalDoc,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
